import {
    AckoMainTheme,
    ThemeProvider,
} from '@acko-tech/building-blocks.ui.theme';
import Header from 'widgets/header';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { PageLoader } from 'utils/styles';
import { getImageBasePath } from 'utils/generics';
import axios from 'axios';
import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';
import Success from './success';
import Failure from './failure';
import ErrorPage from 'widgets/errorScreen';
import { MPosContext } from 'utils/context';
import { useFetchParams } from 'hooks/useFetchParams';
import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics';
import { SegmentPages, SegmentViewEvents } from 'utils/segment/constants';

function Thankyou() {
    const router = useRouter();
    const { partnerId, dealerType } = useContext(MPosContext);
    const { partner, payment_mode, payment_order_ekey } = router.query;
    const { lob } = useFetchParams();
    const [paymentStatus, setPaymentStatus] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (payment_mode === 'customer') {
            setIsLoading(false);
            return;
        }
        async function getPaymentStatus() {
            try {
                const { status, data } = await axios({
                    method: 'GET',
                    url: `${getDomainOrigin()}/api/mpos/partner/${partner}/payment`,
                    params: {
                        payment_order_ekey,
                        user_type: 'dealer',
                    },
                    ...getAxiosConfig(),
                });
                if (status === 200 && data) {
                    setErrorMessage('');
                    setPaymentStatus(data);
                    const eventName =
                        data === 'success'
                            ? SegmentViewEvents.VIEW_PAYMENT_SUCCESS
                            : SegmentViewEvents.VIEW_PAYMENT_FAILURE;
                    pageEvent(eventName, {
                        page: SegmentPages.PAYMENT,
                        partner: partnerId,
                        product: 'pos',
                        journey: 'buy',
                        platform: 'mweb',
                        type: dealerType,
                    });
                }
            } catch {
                setErrorMessage('Oops. Something went wrong.');
            } finally {
                setIsLoading(false);
            }
        }
        getPaymentStatus();
    }, []);

    const goHome = () => {
        router.push(`/${lob}/${partnerId}/dashboard`);
    };

    if (isLoading) {
        return (
            <>
                <Header />
                <PageLoader src={getImageBasePath('/gif/pageLoader.gif')} />
            </>
        );
    }

    if (errorMessage || payment_mode === 'customer') {
        return (
            <>
                <ErrorPage />;
            </>
        );
    }

    return (
        <ThemeProvider theme={AckoMainTheme}>
            <div style={{ padding: '20px' }}>
                <Header />
                {paymentStatus === 'success' ? (
                    <Success
                        text={'Congratulations!'}
                        subText={'Your device is now protected'}
                        description={
                            'Your plan and coverage details are being sent to your registered mobile number'
                        }
                        btnName={'Go Home'}
                        onClick={goHome}
                    />
                ) : (
                    <Failure
                        text={'Payment failed!'}
                        subText={'Oops. Something went wrong.'}
                        description={
                            'Please contact the showroom dealer for more details.'
                        }
                        btnName={'Go Home'}
                        onClick={goHome}
                    />
                )}
            </div>
        </ThemeProvider>
    );
}

export default Thankyou;
